export default __webpack_public_path__ + "static/media/logo_contact_color.f3cfe02b.png";